// Shopping list category codes + Norwegian labels + pantry→shopping map.
// Used by ShoppingList page + extracted dialogs/utilities.

export const CATEGORIES = ["Produce", "Dairy", "Meat", "Fish", "Grill", "Bakery", "Pantry", "Frozen", "Spices", "Other"];

export const CATEGORY_LABELS = {
  Produce: "Frukt & Grønt",
  Dairy: "Meieri",
  Meat: "Kjøtt",
  Fish: "Fisk",
  Grill: "Grillmat",
  Bakery: "Bakevarer",
  Pantry: "Tørrvarer",
  Frozen: "Frysevarer",
  Spices: "Krydder",
  Other: "Annet",
};

// Map pantry (Norwegian) category codes → shopping category codes.
// Mirrors backend PANTRY_TO_SHOPPING_CAT so suggestions pre-fill the correct group.
export const PANTRY_TO_SHOPPING = {
  "Frukt": "Produce", "Grønnsaker": "Produce",
  "Meieri": "Dairy", "Egg": "Dairy",
  "Kjøtt": "Meat", "Fisk": "Fish", "Grillmat": "Grill", "Pålegg": "Meat",
  "Kjøtt & Fisk": "Meat",
  "Bakevarer": "Bakery", "Mel & Bake": "Bakery",
  "Frysevarer": "Frozen", "Krydder": "Spices",
  "Pasta & Ris": "Pantry", "Hermetikk": "Pantry", "Saus & Dressing": "Pantry",
  "Snacks": "Pantry", "Drikke": "Pantry",
  "Renhold": "Other", "Bad": "Other", "Annet": "Other",
};
